import React, { useState, useEffect, useCallback } from "react";
import MessageList from "./MessageList";
import DragImageView from "../components/DragImageView";
import { useOpenAIChatContext } from "../contexts/OpenAIChatContext";
import styles from "../styles/ChatContainerStyles";
import {
  StyledDropdownMenu,
  StyledButton,
  StyledContainer,
  StyledText,
  StyledImage,
} from "app-builder-sdk";
import arrowUpIcon from "../assets/icon-arrow-up.svg";
import arrowDownIcon from "../assets/icon-arrow-down.svg";

const ChatContainer = () => {
  const {
    messages,
    setMessages,
    handleNormalChat,
    handleModifyFiles,
    handleAppBuilderRequest,
    inputText,
    setInputText,
  } = useOpenAIChatContext();
  const [selectedModel, setSelectedModel] = useState("gpt-4o-mini");
  const [selectedMode, setSelectedMode] = useState("Normal Chat");
  const [isMobile, setIsMobile] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState({
    model: false,
    mode: false,
  });

  const modelOptions = [
    {
      node: <StyledText text="gpt-4o-mini" fontSize="16px" fontColor="#000" />,
      nodeHover: (
        <StyledText
          text="gpt-4o-mini"
          fontSize="16px"
          fontColor="#ff6600"
          fontWeight="bold"
        />
      ),
      onClick: () => setSelectedModel("gpt-4o-mini"),
    },
    {
      node: <StyledText text="gpt-4o" fontSize="16px" fontColor="#000" />,
      nodeHover: (
        <StyledText
          text="gpt-4o"
          fontSize="16px"
          fontColor="#ff6600"
          fontWeight="bold"
        />
      ),
      onClick: () => setSelectedModel("gpt-4o"),
    },
  ];

  const modeOptions = [
    {
      node: <StyledText text="Normal Chat" fontSize="16px" fontColor="#000" />,
      nodeHover: (
        <StyledText
          text="Normal Chat"
          fontSize="16px"
          fontColor="#ff6600"
          fontWeight="bold"
        />
      ),
      onClick: () => setSelectedMode("Normal Chat"),
    },
    {
      node: <StyledText text="Modify Files" fontSize="16px" fontColor="#000" />,
      nodeHover: (
        <StyledText
          text="Modify Files"
          fontSize="16px"
          fontColor="#ff6600"
          fontWeight="bold"
        />
      ),
      onClick: () => setSelectedMode("Modify Files"),
    },
    {
      node: (
        <StyledText text="App Builder Mode" fontSize="16px" fontColor="#000" />
      ),
      nodeHover: (
        <StyledText
          text="App Builder Mode (Caution, too powerful!)"
          fontSize="16px"
          fontColor="#ff6600"
          fontWeight="bold"
        />
      ),
      onClick: () => setSelectedMode("App Builder Mode"),
    },
  ];

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200);
    const handleResize = () => setIsMobile(window.innerWidth <= 1200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSend = () => {
    if (inputText.trim()) {
      if (selectedMode === "Normal Chat") {
        handleNormalChat(inputText, selectedModel);
      } else if (selectedMode === "Modify Files") {
        handleModifyFiles(inputText, selectedModel);
      } else if (selectedMode === "App Builder Mode") {
        handleAppBuilderRequest(inputText, selectedModel);
      }
      setInputText("");
    }
  };

  const handleClearMessages = () => {
    setMessages([]);
    setInputText("");
  };

  const messagesContainerStyle = isMobile
    ? { ...styles.messagesContainer, flex: 3 }
    : styles.messagesContainer;

  const inputContainerStyle = isMobile
    ? {
        ...styles.inputContainer,
        flexDirection: "column",
        gap: "10px",
      }
    : styles.inputContainer;

  const handleModelMenuOpen = useCallback(() => {
    setDropdownOpen((prev) => ({ ...prev, model: true }));
  }, []);

  const handleModelMenuClose = useCallback(() => {
    setDropdownOpen((prev) => ({ ...prev, model: false }));
  }, []);

  const handleModeMenuOpen = useCallback(() => {
    setDropdownOpen((prev) => ({ ...prev, mode: true }));
  }, []);

  const handleModeMenuClose = useCallback(() => {
    setDropdownOpen((prev) => ({ ...prev, mode: false }));
  }, []);

  return (
    <div style={styles.container}>
      <button onClick={handleClearMessages} style={styles.clearButton}>
        Clear
      </button>

      <div style={messagesContainerStyle}>
        <MessageList messages={messages} styles={styles} />
      </div>

      <DragImageView />

      <div style={inputContainerStyle}>
        <StyledDropdownMenu
          options={modelOptions}
          onMenuOpen={handleModelMenuOpen}
          onMenuClose={handleModelMenuClose}
        >
          <StyledButton
            backgroundColor="#23a6d5"
            padding="8px 16px"
            borderRadius="24px"
            onClick={() => {}}
          >
            <StyledContainer spacing="8px">
              <StyledText
                text={selectedModel}
                fontSize="16px"
                fontColor="#fff"
              />
              <StyledImage
                src={isDropdownOpen.model ? arrowUpIcon : arrowDownIcon}
                width="16px"
                height="16px"
              />
            </StyledContainer>
          </StyledButton>
        </StyledDropdownMenu>
        <StyledDropdownMenu
          options={modeOptions}
          onMenuOpen={handleModeMenuOpen}
          onMenuClose={handleModeMenuClose}
        >
          <StyledButton
            backgroundColor="#23a6d5"
            padding="8px 16px"
            borderRadius="24px"
            onClick={() => {}}
          >
            <StyledContainer spacing="8px">
              <StyledText
                text={selectedMode}
                fontSize="16px"
                fontColor="#fff"
              />
              <StyledImage
                src={isDropdownOpen.mode ? arrowUpIcon : arrowDownIcon}
                width="16px"
                height="16px"
              />
            </StyledContainer>
          </StyledButton>
        </StyledDropdownMenu>

        <textarea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Type a message..."
          style={styles.textAreaInput}
          rows={isMobile ? 2 : 3}
        />

        <button onClick={handleSend} style={styles.sendButton}>
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatContainer;
